import { TApiResCities } from '@app/core/models/region.model';
import { createAction, props } from '@ngrx/store';

export const setCities = createAction('[Cities] Set cities', props<{ value: TApiResCities }>());
